module.exports = __webpack_public_path__ + "site/img/40.be286dae.jpg";